export function getNameVariations(firstName = '', lastName = '') {
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`;
  const fullName = `${firstName} ${lastName}`.trim();

  return {
    initials,
    fullName,
  };
}
